import React, { useEffect, useState } from "react";
import { LineChart as LineIcon, Eye, Radio, Package, DollarSign } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, PageHead, money } from "@/components/common";

export default function Insights() {
  const [summary, setSummary] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/seller/summary"), api.get("/seller/orders")])
      .then(([s, o]) => { setSummary(s); setOrders(o.orders); }).catch(() => {});
  }, []);
  if (!summary) return <Loading />;

  // sales revenue by day, last 14 days
  const days = [...Array(14)].map((_, i) => {
    const d = new Date(); d.setDate(d.getDate() - (13 - i));
    return d.toISOString().slice(0, 10);
  });
  const revByDay = Object.fromEntries(days.map((d) => [d, 0]));
  orders.forEach((o) => {
    const d = (o.created_at || "").slice(0, 10);
    if (d in revByDay && o.status !== "refunded") revByDay[d] += Number(o.amount || 0);
  });
  const max = Math.max(1, ...Object.values(revByDay));

  return (
    <div className="fade-up">
      <PageHead title="Insights" sub="Performance across your live shows." />
      <div className="ss-grid grid-4">
        <div className="ss-card stat-card"><div className="stat-ic"><DollarSign size={22} /></div><div><div className="stat-val">{money(summary.gross)}</div><div className="stat-label">Gross sales</div></div></div>
        <div className="ss-card stat-card"><div className="stat-ic"><Package size={22} /></div><div><div className="stat-val">{summary.orders.total}</div><div className="stat-label">Orders</div></div></div>
        <div className="ss-card stat-card"><div className="stat-ic"><Radio size={22} /></div><div><div className="stat-val">{summary.shows}</div><div className="stat-label">Shows hosted</div></div></div>
        <div className="ss-card stat-card"><div className="stat-ic"><Eye size={22} /></div><div><div className="stat-val">{summary.listings}</div><div className="stat-label">Items listed</div></div></div>
      </div>

      <div className="ss-card" style={{ padding: 20, marginTop: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 800, marginBottom: 16 }}><LineIcon size={18} style={{ color: "var(--gold-2)" }} /> Sales revenue (14 days)</div>
        <div className="bars">
          {days.map((d) => (
            <div className="bar-col" key={d} title={`${d}: ${money(revByDay[d])}`}>
              <div className="bar" style={{ height: `${(revByDay[d] / max) * 100}%`, background: "var(--gold)" }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
